export default __webpack_public_path__ + "static/media/box-arrow.12cc0e25.png";